// Add your custom JS here.

/////////////// Select2 Script ////////////////////
jQuery(document).ready(function($) {
    var userLang = navigator.language || navigator.userLanguage;
    userLang = userLang ? userLang : 'fr';

    $('select.select2').select2({
        language: userLang,
        theme: "default",//"bootstrap4",
    });
});



//////////////////// Workgroup Script //////////////////////
jQuery(document).ready(function($) {
    // Check if the current page is the workgroup page
    if ($('body').hasClass('single-um_groups')) {
        
        //Auto scroll to the .current article in .archive-lorier-resources
        var currentArticle = $('.archive-lorier-resources article.current');
        if (currentArticle.length) {
            var container = $('.archive-lorier-resources');
            var scrollTo = currentArticle.position().top - container.position().top - 75; // Position relative au parent scrollable
            
            container.animate({
                scrollTop: scrollTo
            }, 500); // Durée de l'animation en millisecondes
        }
    }
});